/* TimeLab home media (config from the "TimeLab · medios home" section in the header group):
   1. Hero slides -> videos, keeping each slide's framing (image box + object-position + fade mask copied).
   2. "Inside TimeLab" story image -> crossfading video slideshow.
   3. "Watch culture apparel" band image -> crossfading image slideshow (current image first + extra images).
   2 and 3 reuse assets/tle-band.js (crossfade + slow zoom like the hero, styles in assets/tle-tint.css).
   Rebuilds itself when the theme editor re-renders the config section. */
(function () {
  var COPY = ['objectFit', 'objectPosition', 'webkitMaskImage', 'maskImage', 'webkitMaskSize', 'maskSize', 'webkitMaskPosition', 'maskPosition', 'webkitMaskRepeat', 'maskRepeat', 'filter'];
  function sync(img, v) {
    var cs = getComputedStyle(img);
    v.style.position = 'absolute';
    v.style.top = img.offsetTop + 'px';
    v.style.left = img.offsetLeft + 'px';
    v.style.width = img.offsetWidth + 'px';
    v.style.height = img.offsetHeight + 'px';
    v.style.right = 'auto'; v.style.bottom = 'auto'; v.style.maxWidth = 'none'; v.style.minWidth = '0'; v.style.transform = 'none';
    COPY.forEach(function (p) { if (cs[p] !== undefined) v.style[p] = cs[p]; });
    img.style.visibility = 'hidden';
  }
  function mkVideo(url, poster, preload) {
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    v.preload = preload; v.src = url; if (poster) v.poster = poster;
    return v;
  }
  var heroBound = false;
  function heroSetup(list) {
    var slides = document.querySelectorAll('.tlr__hero-media [data-tlr-slide]');
    if (!slides.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, pairs = [];
    document.querySelectorAll('.tlr__hero-media video.tle-hero-video').forEach(function (v) { v.remove(); });
    slides.forEach(function (s) { var i = s.querySelector('img'); if (i) i.style.visibility = ''; });
    list.forEach(function (it) {
      var slide = slides[(it.slide || 1) - 1];
      if (!slide || !it.url) return;
      var img = slide.querySelector('img');
      var v = mkVideo(it.url, img && (img.currentSrc || img.src), 'auto');
      v.className = 'tle-hero-video';
      slide.appendChild(v);
      pairs.push({ slide: slide, img: img, v: v });
    });
    function refresh() {
      pairs.forEach(function (p) {
        if (!p.v.isConnected) return;
        if (p.img) sync(p.img, p.v);
        if (p.slide.classList.contains('is-active') && !reduce && document.visibilityState !== 'hidden') { var r = p.v.play(); if (r && r.catch) r.catch(function () {}); }
        else p.v.pause();
      });
    }
    refresh();
    pairs.forEach(function (p) { new MutationObserver(refresh).observe(p.slide, { attributes: true, attributeFilter: ['class'] }); if (p.img) p.img.addEventListener('load', refresh); });
    if (!heroBound) {
      heroBound = true;
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { window.__tleHeroRefresh && window.__tleHeroRefresh(); }, 150); });
      document.addEventListener('visibilitychange', function () { window.__tleHeroRefresh && window.__tleHeroRefresh(); });
    }
    window.__tleHeroRefresh = refresh;
  }
  function slideshow(media, items, speed) {
    if (!media) return false;
    var prev = media.querySelector('.tle-media-slides'); if (prev) prev.remove();
    var old = media.querySelector('img');
    if (!items.length) { if (old) old.style.visibility = ''; return false; }
    var wrap = document.createElement('div');
    wrap.className = 'tle-media-slides';
    wrap.setAttribute('data-tle-band-videos', '');
    wrap.setAttribute('data-speed', speed || 6000);
    items.forEach(function (it) {
      var f = document.createElement('figure');
      f.className = 'tle-col__band-slide'; f.setAttribute('data-tle-band-slide', '');
      if (it.video) { f.appendChild(mkVideo(it.video, it.poster, 'metadata')); }
      else { var im = document.createElement('img'); im.src = it.img; im.alt = it.alt || ''; im.decoding = 'async'; f.appendChild(im); }
      wrap.appendChild(f);
    });
    if (old) old.style.visibility = 'hidden';
    media.insertBefore(wrap, media.firstChild);
    return true;
  }
  function loadBand(src) {
    if (window.tleBandScan) { window.tleBandScan(); return; }
    if (document.querySelector('script[data-tle-band]')) return;
    var s = document.createElement('script'); s.src = src; s.defer = true; s.setAttribute('data-tle-band', ''); document.head.appendChild(s);
  }
  function setup() {
    var cfg = document.querySelector('[data-tle-hero-videos]');
    if (!cfg || cfg.dataset.done) return;
    cfg.dataset.done = '1';
    var hero = [], story = [], apparel = [];
    try {
      hero = JSON.parse(cfg.getAttribute('data-tle-hero-videos')) || [];
      story = JSON.parse(cfg.getAttribute('data-tle-story-videos') || '[]') || [];
      apparel = JSON.parse(cfg.getAttribute('data-tle-apparel-images') || '[]') || [];
    } catch (e) { return; }
    heroSetup(hero);
    var used = false;
    story = story.filter(function (s) { return s && s.url; }).map(function (s) { return { video: s.url, poster: s.poster }; });
    used = slideshow(document.querySelector('.tlr__story-media'), story, Number(cfg.getAttribute('data-story-speed'))) || used;
    apparel = apparel.filter(function (s) { return s && s.img; });
    var am = document.querySelector('.tlr__apparel-media');
    if (am) {
      var first = am.querySelector(':scope > img, :scope > picture img');
      var items = apparel.length && first ? [{ img: first.currentSrc || first.src, alt: first.alt }] : [];
      used = slideshow(am, items.concat(apparel), Number(cfg.getAttribute('data-apparel-speed'))) || used;
    }
    if (used) loadBand(cfg.getAttribute('data-band-src'));
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); } else { setup(); }
  window.addEventListener('load', setup);
  document.addEventListener('shopify:section:load', function () { setTimeout(setup, 50); });
})();